/**
 * Constantes pour le module academic-periods
 */

export const MAX_PERIOD_NAME_LENGTH = 64
export const DATE_FORMAT_REGEX = /^\d{4}-\d{2}-\d{2}$/
export const MIN_PERIOD_NUMBER = 1
export const MAX_PERIOD_NUMBER = 12

/**
 * Messages d'erreur
 */
export const ACADEMIC_PERIOD_ERRORS = {
  NOT_FOUND: 'Période académique non trouvée',
  NOT_ACCESSIBLE: 'Période académique non accessible',
  ALREADY_DELETED: 'Période académique déjà supprimée',
  INVALID_DATE_FORMAT: 'Format de date invalide (attendu: YYYY-MM-DD)',
  INVALID_DATE_RANGE: 'La date de fin doit être postérieure à la date de début',
  INVALID_SCHOOL_YEAR: 'Année scolaire invalide',
  INVALID_ESTABLISHMENT: 'Établissement invalide',
  DUPLICATE_PERIOD: 'Numéro de période déjà utilisé pour cet établissement et année scolaire',
  CREATION_FAILED: 'Erreur lors de la création',
  UPDATE_FAILED: 'Erreur lors de la mise à jour',
  DELETE_FAILED: 'Erreur lors de la suppression',
} as const

/**
 * Opérations pour les metrics
 */
export const ACADEMIC_PERIOD_OPERATIONS = {
  CREATE: 'create_academic_period',
  FIND_ALL: 'findMany_academic_periods',
  FIND_ONE: 'findOne_academic_period',
  FIND_BY_ESTABLISHMENT: 'findByEstablishment_academic_periods',
  FIND_BY_SCHOOL_YEAR: 'findBySchoolYear_academic_periods',
  UPDATE: 'update_academic_period',
  DELETE: 'delete_academic_period',
} as const

/**
 * Messages de log pour les opérations
 */
export const ACADEMIC_PERIOD_LOG_MESSAGES = {
  CREATING: (userId: string, name: string) =>
    `[User ${userId}] Création période académique: ${name}`,
  CREATED: (id: string) => `Academic period created successfully: ${id}`,
  UPDATING: (userId: string, id: string) =>
    `[User ${userId}] Mise à jour période académique: ${id}`,
  UPDATED: (id: string) => `Academic period updated successfully: ${id}`,
  DELETING: (userId: string, id: string) =>
    `[User ${userId}] Suppression période académique: ${id}`,
  DELETED: (id: string) => `Academic period deleted successfully: ${id}`,
  FOUND: (count: number, userId: string) =>
    `Found ${count} academic periods for user ${userId}`,
} as const

/**
 * Contextes d'erreur pour ServiceErrorHandler
 */
export const ACADEMIC_PERIOD_ERROR_CONTEXTS = {
  CREATE: 'create academic period',
  FETCH_ALL: 'fetch academic periods',
  FETCH_ONE: 'fetch academic period',
  FETCH_BY_ESTABLISHMENT: 'fetch academic periods by establishment',
  FETCH_BY_SCHOOL_YEAR: 'fetch academic periods by school year',
  UPDATE: 'update academic period',
  DELETE: 'delete academic period',
} as const

/**
 * Actions PolicyEngine
 */
export const ACADEMIC_PERIOD_POLICY_ACTIONS = {
  CREATE: 'academicPeriod:create',
  VIEW: 'academicPeriod:view',
  UPDATE: 'academicPeriod:update',
  DELETE: 'academicPeriod:delete',
} as const
